<div class="overflow-hidden rounded-lg shadow-sm">
  <div class="grid gap-4 bg-white p-6 sm:p-4">
    <div class="text-xl font-medium sm:text-lg xs:text-sm">
      <ng-content select="[slot='title']"></ng-content>
    </div>
    <ng-content select="[slot='content']"></ng-content>
  </div>
</div>
